import { render, staticRenderFns } from "./EstadisticasSegundaVuelta2026.vue?vue&type=template&id=1d67b26c"
import script from "./EstadisticasSegundaVuelta2026.vue?vue&type=script&lang=js"
export * from "./EstadisticasSegundaVuelta2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports